import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/src/assets/backgroundVectors/AboutUsLeftVectorBlue.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/backgroundVectors/AboutUsMobileVector.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/fourPersonImage.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/assets/iconComponents/OmossButtonRightArrow.jsx");
